export const HEADER = {
  FULL: 'full',
  SMART: 'smart',
}
